import requestUtil from '../request-utils.js'

/**
 * 获取子商城信息
 */
function getSubMallInfoList() {
	return new Promise((resolve, reject) => {
		requestUtil.jackyunPost({
			method: 'jmall.auth.getsubmallinfolist'
		}, (res => {
			let data = [];
			if (res.code == 200) {
				data = res.result.data || [];
			}
			resolve(data);
		}));
	});
}

/**
 * 获取吉商城订购信息
 */
function getProductOrderInfo() {
	return new Promise((resolve, reject) => {
		requestUtil.jackyunPost({
			method: 'jmall.auth.getjmallproductorderinfo'
		}, (res => {
			let data = {};
			if (res.code == 200) {
				data = res.result.data || {};
			}
			// 异常数据兼容处理
			// 线上出现问题返回结果为：{code:400}，没有任何报错信息
			// 这种情况先给个正确结果
			if (!res.hasOwnProperty('code') || (res.code == 400 && (!res.msg || res.msg == "接口请求异常"))|| (res.code == 401 )) {
				data = {
				productCode: "trial",
				isExpired: false
				};
			}
			resolve(data);
		}));
	});
}

export {
	getSubMallInfoList,
	getProductOrderInfo
}